import { type GetStaticProps } from "next";
import { useTranslation } from "next-i18next";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import { NextSeo } from "next-seo";
import { useRouter } from "next/router";
import { FAQView } from "@looksrare/poke-the-bear";
import { useCurrentChainInfo } from "@looksrare/utils";
import { getCanonicalAndLanguageAlternates } from "config/seo";
import { WinPageLayout } from "views/win/WinPageLayout";
import { LRPtbProvider } from "components/LRPtbProvider";

const FAQPage = () => {
  const { t } = useTranslation();
  const router = useRouter();
  const currentChainInfo = useCurrentChainInfo();

  const title = "Poke The Bear";
  const description = "Poke The Bear - FAQ";
  const { canonical, languageAlternates } = getCanonicalAndLanguageAlternates(
    "/poke-the-bear/faq",
    router,
    currentChainInfo.appUrl
  );

  return (
    <WinPageLayout isForceDarkMode>
      <NextSeo
        noindex
        nofollow
        title={title}
        description={description}
        openGraph={{
          url: canonical,
          title: t("{{pageTitle}} | LooksRare", { pageTitle: title }),
          description: description,
          images: [
            {
              url: `${currentChainInfo.appUrl}/images/poke-the-bear/meta.png`,
              alt: "Poke The Bear",
              width: 1600,
              height: 900,
              type: "image/png",
            },
          ],
        }}
        canonical={canonical}
        languageAlternates={languageAlternates}
      />
      <LRPtbProvider>
        <FAQView />
      </LRPtbProvider>
    </WinPageLayout>
  );
};

export const getStaticProps: GetStaticProps = async ({ locale = "en" }) => {
  return {
    props: {
      ...(await serverSideTranslations(locale, ["ptb", "common", "localization", "errors"])),
    },
  };
};

export default FAQPage;
